export const nombreTurno = (id) => ({ dia: 'Día', noche: 'Noche', dia_completo: 'Día completo' }[id] || '—');
